module.exports = __webpack_public_path__ + "img/26.3f8c30a9.jpg";